<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">

    <!--操控-->
    <!-- <el-row style="color: #999;margin-left: 20px;">
          <el-col :span="8">门状态：<span :style="{color: byIndicatorLightStatus===0? '#F95453' : '#15DEB5'}">{{
              byIndicatorLightStatus === 0 ? '不在线' : '在线'
            }}</span></el-col>
    </el-row> -->
    <!--      开门记录-->
    <el-row style="padding: 20px">
      <el-table
        :data="doorLogs.records"
        :height="tableHeight"
        border
        class="m-auto"
        style="width: 100%;">
        <el-table-column
          align="center"
          label="卡号"
          prop="card"
         >
        </el-table-column>
        <el-table-column
          align="center"
          label="人员名称"
          prop="name">
        </el-table-column>
        <el-table-column
          align="center"
          label="工号"
          prop="number">
        </el-table-column>
        <el-table-column
          align="center"
          label="开门类型"
          prop="log">
        </el-table-column>
        <el-table-column
          align="center"
          label="开门时间"
          prop="time">
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      :current-page="doorLogs.current" :hide-on-single-page="true"
      :page-size="doorLogs.size"
      :small="true"
      :total="doorLogs.total"
      class="mb-4 mt-3 text-center"
      layout="prev, pager, next"
      style="padding-left: 35px;width: 92%;"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>

<script>
import {getHikvisionAccessControl, } from "@/network/entranceguard";

export default {
  name: "ZkDoor",
  props: ['deviceInfo'],
  data() {
    return {
      // 开门记录
      doorLogs: {},
      page: {
        data: {
          max: 10,
          index: 1
        }
      }
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.40
    }
  },
  mounted() {
    this.getData(this.page.data.index, this.page.data.max, this.deviceInfo.id)
  },
  methods: {
    getData(index, max, id) {
      getHikvisionAccessControl(index, max, id).then(res => {
        if (res.code === 0) {
          this.doorLogs = res.data
        }
      })
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.deviceInfo.id)
    },
  }
}
</script>

<style scoped>

</style>
